import { render, staticRenderFns } from "./Template3.vue?vue&type=template&id=94b6a484"
import script from "./Template3.vue?vue&type=script&lang=js"
export * from "./Template3.vue?vue&type=script&lang=js"
import style0 from "./Template3.vue?vue&type=style&index=0&id=94b6a484&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports